interface NavTarget {
  type: string;
  id?: string;
}

interface History {
  push: (location: { pathname: string; search?: string }) => void;
  replace: (location: { pathname: string; search?: string }) => void;
}

export const navigateTo = (history: History, navTarget: NavTarget, method: 'push' | 'replace' = 'push'): void => {
  // navTarget Object
  // type required
  // target optional
  let pathname = null;
  let search = null;
  let params = null;
  switch (navTarget.type) {
    case 'playback':
      if (navTarget.id) {
        pathname = `/playback`;
        params = new URLSearchParams();
        params.set('video', navTarget.id);
        params.set('row', '');
        search = params.toString();
      }
      break;
    default:
      pathname = '/';
  }
  if (pathname) history[method]({ pathname, ...(search ? { search } : {}) });
};

export const getNavTarget = (url: string): { type: string | null; id: string | null } => {
  let type;
  let id = null;

  try {
    let paths = url.split('/');
    if (paths.indexOf('playback') !== -1) {
      if (paths.indexOf('playback') > 1) {
        paths = paths.slice(paths.indexOf('playback'));
      }
      paths.shift();
      [id] = paths;
      type = 'playback';
    }
    return { type, id };
  } catch (e) {
    return { type: null, id: null };
  }
};
